export default __webpack_public_path__ + "8530573be9c9384f772364014797d390.svg";